import type { BucketProduct } from './bucket.types'

export const bucketCatalog = [
  {
    id: 'puff-clusters',
    name: 'Puff Clusters',
    image: '/products/puff-clusters.jpg',
    priceCents: 1000,
    tags: ['freeze-dried', 'fruity'],
  },
  {
    id: 'rainbow-treats',
    name: 'Rainbow Treats',
    image: '/products/rainbow-treats.jpg',
    priceCents: 1000,
    tags: ['freeze-dried', 'fruity'],
  },
  {
    id: 'pick-mix-200',
    name: 'Pick & Mix 200g',
    image: '/products/pick-mix-higgsfield.webp',
    priceCents: 700,
    tags: ['fruity', 'sour'],
  },
  {
    id: 'fudge',
    name: 'Fudge',
    image: '/products/fudge.jpg',
    priceCents: 600,
    tags: ['chocolate', 'caramel'],
  },
  {
    id: 'dubai-cookie',
    name: 'Dubai Cookie',
    image: '/products/dubai-cookie.jpg',
    priceCents: 1200,
    tags: ['chocolate'],
  },
] as const satisfies readonly BucketProduct[]
